const initialState = {
  list: [],
  currentIndex: 0,
};

export const SET_TIMESHEET_LIST = 'SET_TIMESHEET_LIST';
export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX';
export const NEXT_TIMESHEET = 'NEXT_TIMESHEET';
export const PREV_TIMESHEET = 'PREV_TIMESHEET';
export const REMOVE_TIMESHEET = 'REMOVE_TIMESHEET';

export default function timesheetNavigationReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case SET_TIMESHEET_LIST:
      return { ...state, list: action.payload, currentIndex: 0 };

    case SET_CURRENT_INDEX:
      return { ...state, currentIndex: action.payload };

    case NEXT_TIMESHEET:
      return {
        ...state,
        currentIndex: (state.currentIndex + 1) % state.list.length,
      };

    case PREV_TIMESHEET:
      return {
        ...state,
        currentIndex:
          (state.currentIndex - 1 + state.list.length) % state.list.length,
      };

    case REMOVE_TIMESHEET: {
      const newList = state.list.filter((_, idx) => idx !== state.currentIndex);
      let newIndex = state.currentIndex;

      if (newList.length === 0) {
        newIndex = 0;
      } else if (state.currentIndex >= newList.length) {
        newIndex = 0;
      }

      return {
        list: newList,
        currentIndex: newIndex,
      };
    }

    default:
      return state;
  }
}
